module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-custom"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-calendar pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.agenda.formatedDate))])]), _vm._v(" "), (_vm.agenda.horas && _vm.agenda.horas.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.agenda.horas), function(slot) {
    return _c('tr', [_c('td', [(slot.status.id === 1) ? [_c('router-link', {
      attrs: {
        "to": ("/agendas/" + (_vm.$route.params.data) + "-" + (slot.hora) + "/cadastro?slot=" + (slot.id))
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(slot.hora) + "\n\t\t\t\t\t\t")])] : [_vm._v("\n\t\t\t\t\t\t" + _vm._s(slot.hora) + "\n\t\t\t\t\t")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-uppercase"
    }, [(slot.status.id === 1) ? [_c('router-link', {
      attrs: {
        "to": ("/agendas/" + (_vm.$route.params.data) + "-" + (slot.hora) + "/cadastro?slot=" + (slot.id))
      }
    }, [(slot.status.id === 1) ? _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(slot.status.nome) + ". CLIQUE PARA AGENDAR")]) : _vm._e()])] : [(slot.status.id === 2 || slot.status.id === 4) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(slot.status.nome))]) : _vm._e(), _vm._v(" "), (slot.status.id === 3) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(slot.status.nome))]) : _vm._e(), _vm._v(" "), (slot.agendamento) ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v(_vm._s(slot.agendamento.nome.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (slot.agendamento && slot.agendamento.confirmado) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("CONFIRMADO")]) : _vm._e()]], 2)])
  }))]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-warning text-center text-uppercase",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.agenda.observacao))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10"
    }
  }, [_vm._v("HORA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("SITUAÇÃO")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-145b243a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145b243a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/agendas/agenda.vue
// module id = 353
// module chunks = 1